import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Email_Login() {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      {/* Email */}
      <div className="form-group field_holder">
        <Form.Label>
          <img
            src="/assets/images/icons/phone.png"
            alt="icon"
            className="login_lable_icons"
          />
          Email
        </Form.Label>
        <Form.Control type="email" placeholder="Please enter email" />
      </div>

      {/* Password */}
      <div className="form-group field_holder">
        <Form.Label>
          <img
            src="/assets/images/icons/lock.png"
            alt="icon"
            className="login_lable_icons"
          />
          Password
        </Form.Label>

        <div className="password_input">
          <Form.Control
            type={showPassword ? "text" : "password"}
            placeholder="Password"
          />
          <span
            className="eye-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEye /> : <FaEyeSlash />}
          </span>
        </div>
      </div>

    
    </>
  );
}

export default Email_Login;